import Home from "./pages/Home";
import ExplorePage from "./pages/ExplorePage";
import { Route } from "./constants/interfaces";
import RewritePage from "./pages/RewritePage";
import Emails from "./pages/EmailsPage";

export const routes: Array<Route> = [
  {
    key: "home",
    title: "Home",
    path: `${process.env.PUBLIC_URL}/home`,
    enabled: true,
    component: Home,
    index: 0,
  },
  {
    key: "explore",
    title: "Explore",
    path: `${process.env.PUBLIC_URL}/explore`,
    enabled: true,
    component: ExplorePage,
    index: 0,
  },
  {
    key: "rewrite",
    title: "Rewrite",
    path: `${process.env.PUBLIC_URL}/rewrite`,
    enabled: true,
    component: RewritePage,
    index: 0,
  },
  {
    key: "emails",
    title: "Emails",
    path: `${process.env.PUBLIC_URL}/emails`,
    enabled: true,
    component: Emails,
    index: 0,
  },
];
